import React from "react"
import { CircularProgress, Paper, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import useApiLoading from "hooks/useApiLoading"

const useStyles = makeStyles(theme => ({
  progressPaper: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    zIndex: 1101, //header(AppBar)のzIndexが1100
    backgroundColor: "rgba(209, 209, 209, 0.5)",
  },
  root: {
    height: "100vh",
    width: "100vw",
  },
}))

const APILoading = () => {
  const classes = useStyles()
  const { isApiLoading } = useApiLoading()
  if (isApiLoading) {
    return (
      <Paper className={classes.progressPaper}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.root}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
        </Grid>
      </Paper>
    )
  }
  return null
}

export default APILoading
